// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c8Me","left":"styles_left__27Pg2"};